import BREAKPOINTS from '@lib/constants/breakpoints';
import { useMediaQuery } from 'react-responsive';

export function useIsSmall() {
  return useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.medium})`,
  });
}
